<template>
  <div class="r-table r-table--5cols r-table--collapse">
    <!--    table header-->
    <div class="r-table-row r-table-row--head">
      <div class="r-table-cell broker-cell column-heading">
        <div>BRKR</div>
        <div
          @click.stop="applyTableSortingAlphaDeep(['campaign', 'name'])"
          class="fa"
        >
          <i class="fas fa-sort-alpha-down" v-if="!sortOrder['campaign']"></i>
          <i class="fas fa-sort-alpha-up" v-if="sortOrder['campaign']"></i>
        </div>
      </div>
      <div class="r-table-cell dep-date-cell column-heading">
        <div>DATE</div>
        <div @click.stop="applyTableSortingNum('created_at')" class="fa">
          <i
            class="fas fa-sort-numeric-down"
            v-if="!sortOrder['created_at']"
          ></i>
          <i class="fas fa-sort-numeric-up" v-if="sortOrder['created_at']"></i>
        </div>
      </div>
      <div class="r-table-cell dep-time-cell column-heading">
        <div>HR</div>
        <div @click.stop="applyTableSortingAlpha('created_at')" class="fa">
          <i
            class="fas fa-sort-numeric-down"
            v-if="!sortOrder['created_at']"
          ></i>
          <i class="fas fa-sort-numeric-up" v-if="sortOrder['created_at']"></i>
        </div>
      </div>
      <div class="r-table-cell day-time-vector-dep-cell column-heading"></div>
      <div class="r-table-cell client-name-cell column-heading">
        <div>NAME</div>
        <div @click.stop="applyTableSortingAlpha('client_name')" class="fa">
          <i
            class="fas fa-sort-alpha-down"
            v-if="!sortOrder['client_email']"
          ></i>
          <i class="fas fa-sort-alpha-up" v-if="sortOrder['client_name']"></i>
        </div>
      </div>
      <div class="r-table-cell client-email-cell column-heading">
        <div>MAIL</div>
        <div @click.stop="applyTableSortingAlpha('client_email')" class="fa">
          <i
            class="fas fa-sort-alpha-down"
            v-if="!sortOrder['client_email']"
          ></i>
          <i class="fas fa-sort-alpha-up" v-if="sortOrder['client_email']"></i>
        </div>
      </div>
      <div class="r-table-cell country-cell column-heading">
        <div><i class="fas fa-globe-americas"></i></div>
        <div @click.stop="applyTableSortingNum('country_id')" class="fa">
          <i class="fas fa-sort-alpha-down" v-if="!sortOrder['country_id']"></i>
          <i class="fas fa-sort-alpha-up" v-if="sortOrder['country_id']"></i>
        </div>
      </div>
      <div class="r-table-cell amount-cell column-heading">
        <div>AMT</div>
        <div @click.stop="applyTableSortingNum('amount')" class="fa">
          <i class="fas fa-sort-numeric-down" v-if="!sortOrder['amount']"></i>
          <i class="fas fa-sort-numeric-up" v-if="sortOrder['amount']"></i>
        </div>
      </div>
      <div class="r-table-cell currency-cell column-heading">
        <div>$/$</div>
      </div>
      <div class="r-table-cell method-cell column-heading">CC</div>
      <div class="r-table-cell comment-cell column-heading">CM</div>
      <div class="r-table-cell reg-date-cell column-heading">
        <div>REG</div>
        <div @click.stop="applyTableSortingAlpha('registration')" class="fa">
          <i
            class="fas fa-sort-numeric-down"
            v-if="!sortOrder['registration']"
          ></i>
          <i
            class="fas fa-sort-numeric-up"
            v-if="sortOrder['registration']"
          ></i>
        </div>
      </div>
      <div class="r-table-cell reg-time-cell column-heading">
        <div>HR</div>
        <div
          @click.stop="applyTableSortingAlpha('registrationTime')"
          class="fa"
          v-if="false"
        >
          <i
            class="fas fa-sort-numeric-down"
            v-if="!sortOrder['registration']"
          ></i>
          <i
            class="fas fa-sort-numeric-up"
            v-if="sortOrder['registration']"
          ></i>
        </div>
      </div>
      <div class="r-table-cell day-time-vector-reg-cell column-heading"></div>
      <div class="r-table-cell diff-cell column-heading">
        <div>DIFF</div>
        <div
          @click.stop="applyTableSortingNum('difference_numeric')"
          class="fa"
        >
          <i
            class="fas fa-sort-numeric-down"
            v-if="!sortOrder['difference_numeric']"
          ></i>
          <i
            class="fas fa-sort-numeric-up"
            v-if="sortOrder['difference_numeric']"
          ></i>
        </div>
      </div>
      <div class="r-table-cell agent-cell column-heading">
        <div>AGENT</div>
        <div
          @click.stop="applyTableSortingAlphaDeep(['user', 'full_name'])"
          class="fa"
        >
          <i class="fas fa-sort-alpha-down" v-if="!sortOrder['user']"></i>
          <i class="fas fa-sort-alpha-up" v-if="sortOrder['user']"></i>
        </div>
      </div>
      <div class="r-table-cell id-cell column-heading">
        <div>ID</div>
        <div @click.stop="applyTableSortingNum('client_id')" class="fa">
          <i
            class="fas fa-sort-numeric-down"
            v-if="!sortOrder['client_id']"
          ></i>
          <i class="fas fa-sort-numeric-up" v-if="sortOrder['client_id']"></i>
        </div>
      </div>
    </div>
    <!--    table body-->
    <transition-group name="flip-list" tag="div" class="flip-wrapper">
      <div
        class="r-table-row"
        v-for="(dep, index) in deposits[filterOption]"
        :key="dep.id"
        :class="{ 'is-striped': index % 2 != 0 }"
      >
        <div class="r-table-cell broker-cell">
          <div class="r-table-cell--heading">Replay</div>
          <div class="r-table-cell--content replay-link-content">
            {{ dep.campaign.name | truncate(6) }}
          </div>
        </div>
        <div class="r-table-cell dep-date-cell">
          <div class="r-table-cell--heading">Date</div>
          <div class="r-table-cell--content pdf-content">
            {{ formatDate(dep.created_at) }}
          </div>
        </div>
        <div class="r-table-cell dep-time-cell">
          <div class="r-table-cell--heading">Time</div>
          <div class="r-table-cell--content pdf-content">
            {{ formatTime(dep.created_at) }}
          </div>
        </div>
        <div class="r-table-cell day-time-vector-dep-cell">
          <div class="r-table-cell--content pdf-content">
            <i
              :class="timeIcons[checkTimeOfDay(formatTime(dep.created_at))]"
            ></i>
            <!--          {{ timeIcons[checkTimeOfDay(formatTime(dep.created_at))] }}-->
          </div>
        </div>
        <div class="r-table-cell client-name-cell">
          <div class="r-table-cell--content title-content">
            {{ dep.client_email | truncate(7) }}
          </div>
        </div>
        <div class="r-table-cell client-email-cell">
          <div class="r-table-cell--content title-content">
            {{ dep.client_email | truncate(7) }}
          </div>
        </div>
        <div class="r-table-cell country-cell">
          <div class="r-table-cell--heading">Replay</div>
          <div class="r-table-cell--content replay-link-content">
            <img
              class="country-flag"
              :src="
                '/img/flags/' +
                dictionaries.general.countries
                  .find(place => place.id == dep.country_id)
                  .alpha2.toLowerCase() +
                '.png'
                  ? '/img/flags/' +
                    dictionaries.general.countries
                      .find(place => place.id == dep.country_id)
                      .alpha2.toLowerCase() +
                    '.png'
                  : ''
              "
              alt="country-flag"
            />
          </div>
        </div>
        <div class="r-table-cell amount-cell">
          <div class="r-table-cell--heading">AMT</div>
          <div class="r-table-cell--content pdf-content">
            {{ dep.amount }}
          </div>
        </div>
        <div class="r-table-cell currency-cell">
          <div class="r-table-cell--heading">Currency</div>
          <div class="r-table-cell--content pdf-content">
            {{ dep.currency.symbol }}
          </div>
        </div>
        <div class="r-table-cell method-cell">
          <div class="r-table-cell--heading">Method</div>
          <div class="r-table-cell--content pdf-content">
            <span v-if="dep.method.id == 1">CC</span>
            <span v-else>{{ dep.method.method | truncate(5) }}</span>
          </div>
        </div>
        <div class="r-table-cell comment-cell">
          <div class="r-table-cell--heading" v-if="dep.comment">Comment</div>
          <div class="r-table-cell--content pdf-content" v-if="dep.comment">
            {{ dep.comment | truncate(10) }}
          </div>
        </div>
        <div class="r-table-cell reg-date-cell">
          <div class="r-table-cell--heading">Reg</div>
          <div class="r-table-cell--content pdf-content" :class="{}">
            {{ formatDate(dep.registration) }}
          </div>
        </div>
        <div class="r-table-cell reg-time-cell">
          <div
            class="r-table-cell--content pdf-content"
            :class="{
              // reg_hours: checkRegisterTime(formatTime(dep.registration))
            }"
          >
            {{ formatTime(dep.registration) }}
          </div>
        </div>
        <div class="r-table-cell day-time-vector-reg-cell">
          <div
            class="r-table-cell--content pdf-content"
            :class="{
              // reg_hours: checkRegisterTime(formatTime(dep.registration))
            }"
          >
            <i
              :class="timeIcons[checkTimeOfDay(formatTime(dep.registration))]"
            ></i>
          </div>
        </div>
        <div class="r-table-cell diff-cell">
          <div class="r-table-cell--heading">Diff</div>
          <div
            class="r-table-cell--content pdf-content"
            :class="{
              // reg_hours: checkRegisterTime(formatTime(dep.registration))
            }"
          >
            <span class="numeric-diff">{{ dep.difference_numeric }}</span>
            <span>{{ dep.difference }}</span>
          </div>
        </div>
        <div class="r-table-cell agent-cell">
          <div class="r-table-cell--heading"></div>
          <div class="r-table-cell--content access-link-content">
            {{ dep.user.full_name }}
          </div>
        </div>
        <div class="r-table-cell id-cell">
          <div class="r-table-cell--heading">Date</div>
          <div class="r-table-cell--content date-content">
            {{ dep.client_id }}
          </div>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "DepositsTableSorted",
  computed: {
    ...mapState("user", ["auth"]),
    ...mapState("clients", ["dictionaries", "salesPersonList"])
  },
  props: {
    deposits: {
      type: Array
    },
    filterOption: {
      type: String
    }
  },
  data() {
    return {
      // timeIcons: [
      //   "\uD83C\uDF05",
      //   "\uD83C\uDF1E",
      //   "\uD83C\uDF07",
      //   "\uD83C\uDF19"
      // ]
      sortOrder: {
        client_id: false,
        client_email: false,
        client_name: false,
        user: false,
        country_id: false,
        campaign: false,
        amount: false,
        created_at: false,
        registration: false,
        difference_numeric: false
      },
      sortDesc: false,
      timeIcons: [
        "fas fa-sun",
        "fas fa-cloud-moon",
        "fas fa-cloud-sun",
        "fas fa-moon"
      ]
    };
  },
  methods: {
    applyTableSortingNum(column) {
      this.sortOrder[column] = !this.sortOrder[column];
      if (this.sortOrder[column]) {
        this.deposits[this.filterOption] = this.deposits[
          this.filterOption
        ].sort((a, b) => {
          return b[column] - a[column];
        });
      } else {
        this.deposits[this.filterOption] = this.deposits[
          this.filterOption
        ].sort((a, b) => {
          return a[column] - b[column];
        });
      }
    },
    applyTableSortingAlpha(column) {
      this.sortOrder[column] = !this.sortOrder[column];
      if (this.sortOrder[column]) {
        this.deposits[this.filterOption] = this.deposits[
          this.filterOption
        ].sort(function(a, b) {
          if (a[column] > b[column]) {
            return -1;
          }
          if (a[column] < b[column]) {
            return 1;
          }
          return 0;
        });
      } else {
        this.deposits[this.filterOption] = this.deposits[
          this.filterOption
        ].sort(function(a, b) {
          if (a[column] < b[column]) {
            return -1;
          }
          if (a[column] > b[column]) {
            return 1;
          }
          return 0;
        });
      }
    },
    applyTableSortingAlphaDeep(columnArr) {
      this.sortOrder[columnArr[0]] = !this.sortOrder[columnArr[0]];
      if (this.sortOrder[columnArr[0]]) {
        this.deposits[this.filterOption] = this.deposits[
          this.filterOption
        ].sort((a, b) => {
          if (a[columnArr[0]][columnArr[1]] > b[columnArr[0]][columnArr[1]]) {
            return -1;
          }
          if (a[columnArr[0]][columnArr[1]] < b[columnArr[0]][columnArr[1]]) {
            return 1;
          }
          return 0;
        });
      } else {
        this.deposits[this.filterOption] = this.deposits[
          this.filterOption
        ].sort((a, b) => {
          if (a[columnArr[0]][columnArr[1]] < b[columnArr[0]][columnArr[1]]) {
            return -1;
          }
          if (a[columnArr[0]][columnArr[1]] > b[columnArr[0]][columnArr[1]]) {
            return 1;
          }
          return 0;
        });
      }
    },
    checkDayForWeekend(date) {
      return moment(date).weekday() === 0 || moment(date).weekday() === 6;
    },
    checkRegisterTime(time) {
      let format = "hh:mm:ss";

      let timeToCheck = moment(time, format);

      return !timeToCheck.isBetween(
        moment("08:00:00", format),
        moment("23:00:00", format),
        undefined,
        "()"
      );
    },
    checkTimeOfDay(time) {
      let format = "hh:mm:ss";

      let timeToCheck = moment(time, format);
      let midnight = moment("00:00:00", format),
        earlyMorning = moment("06:00:00", format),
        noon = moment("12:00:00", format),
        evening = moment("18:00:00", format),
        night = moment("23:59:59", format);
      if (timeToCheck.isBetween(midnight, earlyMorning, undefined, "[)"))
        return 3;
      if (timeToCheck.isBetween(earlyMorning, noon, undefined, "[)")) return 0;
      if (timeToCheck.isBetween(noon, evening, undefined, "[)")) return 1;
      if (timeToCheck.isBetween(evening, night, undefined, "[)")) return 2;
    },
    formatDate(date) {
      return moment(String(date)).format("DD/MM/YY");
    },
    formatTime(time) {
      return moment(String(time)).format("HH:mm");
    }
  }
};
</script>

<style scoped lang="scss">
/***************** div flex table style  STARTS**********************/
$breakpoint: 750px;
/*$heading-color: #43bac0;*/
$heading-color: #c12fff;

* {
  box-sizing: border-box;
}

.wrapper {
  width: 100%;
  max-width: 1000px;
  margin: 1em auto;
  padding: 1em;
}

.is-striped {
  /*background-color: rgba(233, 200, 147, 0.2);*/
  background-color: #f8f8f8;
}

/* Table column sizing
================================== */
//.id-cell {
//  width: 15%;
//}
.broker-cell {
  flex: 4;
}
.dep-date-cell {
  flex: 2;
}
.dep-time-cell {
  flex: 2;
}
.day-time-vector-dep-cell {
  flex: 1;
}
.client-name-cell {
  flex: 2;
}
.client-email-cell {
  flex: 2;
}
.country-cell {
  flex: 1;
}
.amount-cell {
  flex: 1;
}
.currency-cell {
  flex: 1;
}
.method-cell {
  flex: 1;
}
.comment-cell {
  flex: 2;
}
.reg-date-cell {
  flex: 2;
}
.reg-time-cell {
  flex: 2;
}
.day-time-vector-reg-cell {
  flex: 1;
}
.diff-cell {
  flex: 1;
}
.agent-cell {
  flex: 2;
}
.id-cell {
  flex: 2;
}
/* Apply styles
================================== */
.r-table {
  display: flex;
  flex-wrap: wrap;
  padding: 0;
  height: 100%;
  .r-table-row {
    width: 100%;
    display: flex;

    .r-table-cell {
      box-sizing: border-box;
      flex-grow: 1;
      padding: 0.8em 1.2em;
      //padding: 0.3em 0.5em;
      overflow: hidden; // Or flex might break
      list-style: none;

      &.column-heading {
        background-color: $heading-color;
        color: white;
        padding: 1em;
        display: flex;
        justify-content: center;
      }

      .r-table-cell--heading {
        display: none;
      }

      .r-table-cell--content {
        a {
          font-size: 2em;
          color: #333;
        }

        .webinar-date {
          font-weight: 700;
        }
      }
    }
  }
}

/* Responsive
==================================== */
@media all and (max-width: $breakpoint) {
  .is-striped {
    background-color: white;
  }

  .r-table--collapse {
    display: block;
    width: 100%;
    padding: 1em;
    box-shadow: none;

    .r-table-row {
      box-sizing: border-box;
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 2em;
      //box-shadow: 0 0 40px rgba(0, 0, 0, 0.2);

      .r-table-cell {
        width: 100% !important;
        display: flex;
        align-items: center;

        .r-table-cell--heading {
          display: inline-block;
          flex: 1;
          max-width: 120px;
          min-width: 120px;
          color: $heading-color;
          font-weight: 700;
          border-right: 1px solid #ccc;
          margin-right: 1em;
        }

        .r-table-cell--content {
          flex: 2;
          padding-left: 1em;
        }
      }
    }

    .atm-cell {
      background-color: $heading-color;
      color: white;
      font-weight: 700;
      order: -1;

      .r-table-cell--content {
        padding-left: 0 !important;
      }
    }

    .r-table-row--head {
      display: none;
    }
  }
}

// Non-Flex modernizer fallback
.no-flexbox .r-table {
  display: block;

  &.r-table-cell {
    width: 100%;
  }
}

.date-title {
  font-size: 14px;
  font-weight: 700;
}

/***************** div flex table style ENDS**********************/

/***************** Custom scroll style Starts**********************/

.flip-wrapper::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f5f5f5;
}

.flip-wrapper::-webkit-scrollbar {
  width: 7px;
  background-color: #c12fff;
  /*display: none;*/
}

.flip-wrapper::-webkit-scrollbar-thumb {
  background-color: #c12fff;
  border: 2px solid #a629db;
  border-radius: 5px;
}
/***************** Custom scroll style Ends**********************/

.day_is_weekend {
  background-color: #f9a825;
}
.reg_hours {
  background-color: grey;
}
.numeric-diff {
  display: none;
}
.r-table-row.r-table-row--head {
  font-weight: 700;
}
.fas {
  font-size: 18px;
}
.flip-list-move {
  transition: transform 1s;
}
.flip-wrapper {
  width: 100%;
  overflow-y: scroll;
  max-height: 370px;
  height: 80%;
}
.column-heading div {
  padding-top: 5px;
  margin-right: 10px;
}
</style>
